import React from "react";
import styled from "styled-components";
import VideoUploader from "../../../components/common/VideoUploader";

export function AudioEditor({
  file,
  setFile,
  filePath,
  readOnly = false
}) {
  return (
      <AudioSettingCard>
        <AudioHeader>
          <div>
            <AudioTitle>
              오디오 파일
            </AudioTitle>

            <AudioDescription>
              재생할 오디오 소재를 등록해주세요.
            </AudioDescription>
          </div>
        </AudioHeader>

        <AudioInnerBox>
          <VideoUploader
              file={file}
              onSelect={setFile}
              filePath={filePath}
              readOnly={readOnly}
          />
        </AudioInnerBox>
      </AudioSettingCard>
  );
}

const AudioSettingCard = styled.div`
  width: 100%;
`;

const AudioHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
`;

const AudioTitle = styled.div`
  margin-bottom: 5px;
  color: #222;
  font-size: 17px;
  font-weight: 700;
`;

const AudioDescription = styled.div`
  color: #888;
  font-size: 14px;
  line-height: 1.5;
`;

const FileTypeBadge = styled.span`
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid #f1d4c2;
  border-radius: 13px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: 12px;
  font-weight: 700;
`;

const AudioInnerBox = styled.div`
  width: 100%;
  padding: 16px 18px;
  border: 1px solid #e5e5e5;
  border-left: 3px solid #f5811f;
  border-radius: 0 7px 7px 0;
  background-color: #fff;
`;